import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
    Grid,
    Box,
    Typography,
    Button,
    TextField,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Modal,
} from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import Search from "@material-ui/icons/Search";

import relatorioService from "../../services/relatorioService";
import modeloService from "../../services/modeloService";
import usuarioService from "../../services/usuarioService";
import parameterService from "../../services/parameterService";
import consultarRelatorio from "../../services/consultarRelatorio";

import TableRelatorios from "../../components/TableRelatorios";
import ModalRelatorios from "../../components/ModalRelatorios";

const Relatorios = () => {
    const history = useHistory();

    const [relatorios, setRelatorios] = useState([]);
    const [modelos, setModelos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);

    const [loading, setLoading] = useState(false);

    const [abrirModal, setAbrirModal] = useState(false);

    const [campoBuscar, setCampoBuscar] = useState("");
    const [campoDataInicio, setCampoDataInicio] = useState(undefined);
    const [campoDataFim, setCampoDataFim] = useState(undefined);
    const [campoUsuario, setCampoUsuario] = useState("");
    const [campoTipoConsulta, setCampoTipoConsulta] = useState("");
    const [campoStatus, setCampoStatus] = useState("");

    const [pagina, setPagina] = useState(1);
    const [limite, setLimite] = useState(10);
    const [total, setTotal] = useState(0);

    const [intervalLoop, setIntervalLoop] = useState(true);

    const getJsonFilter = () => {
        return {
            buscar: campoBuscar,
            datainicio: campoDataInicio,
            datafim: campoDataFim,
            usuario: campoUsuario,
            tipoconsulta: campoTipoConsulta,
            status: campoStatus,
            page: pagina,
        };
    };

    const submitRelatorio = async (data) => {
        try {
            const modelo_select = modelos.filter(
                (m) => m.id == data.id_modelo
            )[0];
            const parametros_portal = modelo_select.parametros_portal;

            if (parametros_portal) {
                if (parametros_portal.hidden_parameters instanceof Array) {
                    parametros_portal.hidden_parameters.forEach((item) => {
                        data = parameterService.processHiddenParameterOption(
                            item,
                            data
                        );
                    });
                }

                data.parametros_extra = {
                    ...data.parametros_extra,
                    ...parameterService.getParametrosExtra(
                        parametros_portal,
                        data
                    ),
                };
            }
        } catch (ignore) {}

        setLoading(!loading);
        await consultarRelatorio
            .postconsultarRelatorio(data)
            .then(() => {
                toast.success("Consulta Realizada com Sucesso!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

                fecharModal();
            })
            .catch((e) => {
                toast.error("Você não possui limite de crédito disponível, favor contate seu consultor comercial", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const buscarRelatorios = async (
        buscar = "",
        dataInicio = undefined,
        dataFim = undefined,
        usuario = "",
        modelo = "",
        status = "",
        page = undefined,
        interval = false
    ) => {
        if (!interval) {
            setIntervalLoop(false);
        }

        let dtInicio = dataInicio ? new Date(dataInicio.getTime()) : "";
        if (dataInicio) {
            dtInicio.setHours(0, 0, 0);
            dtInicio = dtInicio.getTime();
        }
        let dtFim = dataFim ? new Date(dataFim.getTime()) : "";
        if (dataFim) {
            dtFim.setHours(23, 59, 59);
            dtFim = dtFim.getTime();
        }

        const paginaRequest = page ? page : 1;
        setPagina(paginaRequest);

        const result = await relatorioService.getRelatorios(
            paginaRequest,
            limite,
            buscar,
            dtInicio,
            dtFim,
            status,
            modelo,
            usuario
        );
        setRelatorios(result.relatorios);
        setTotal(result.total);
        if (!interval) {
            setIntervalLoop(true);
        }
    };

    const changeValue = {
        buscar: (value) => setCampoBuscar(value),
        usuario: (value) => setCampoUsuario(value),
        tipoconsulta: (value) => setCampoTipoConsulta(value),
        status: (value) => setCampoStatus(value),
    };

    const handleChange = async (event) => {
        const key = event.target.name;
        const value = event.target.value;

        if (key && changeValue[key]) {
            changeValue[key](value);
            let paramns = getJsonFilter();
            paramns[key] = value;
            await buscarRelatorios(
                paramns.buscar,
                paramns.datainicio,
                paramns.datafim,
                paramns.usuario,
                paramns.tipoconsulta,
                paramns.status
            );
        }
    };

    const handleChangePage = async (event, newPage) => {
        let paramns = getJsonFilter();

        await buscarRelatorios(
            paramns.buscar,
            paramns.datainicio,
            paramns.datafim,
            paramns.usuario,
            paramns.tipoconsulta,
            paramns.status,
            newPage + 1
        );
    };

    useEffect(async () => {
        let paramns = getJsonFilter();

        await buscarRelatorios(
            paramns.buscar,
            paramns.datainicio,
            paramns.datafim,
            paramns.usuario,
            paramns.tipoconsulta,
            paramns.status,
            1
        );

        let modelos = await modeloService.getModelos();
        setModelos(modelos);

        let usuarios = await usuarioService.buscarTodosPorEmpresa();
        setUsuarios(usuarios);
    }, []);

    const limparFiltros = async () => {
        setCampoBuscar("");
        setCampoDataInicio(undefined);
        setCampoDataFim(undefined);
        setCampoUsuario("");
        setCampoTipoConsulta("");
        setCampoStatus("");
        await buscarRelatorios("", undefined, undefined, "", "", "", 1);
    };

    const alterarData = async (setData, value, key) => {
        setData(value);
        let paramns = getJsonFilter();
        paramns[key] = value;
        await buscarRelatorios(
            paramns.buscar,
            paramns.datainicio,
            paramns.datafim,
            paramns.usuario,
            paramns.tipoconsulta,
            paramns.status
        );
    };

    useEffect(() => {
        if (intervalLoop) {
            const interval = setInterval(async () => {
                let paramns = getJsonFilter();
                if (intervalLoop) {
                    await buscarRelatorios(
                        paramns.buscar,
                        paramns.datainicio,
                        paramns.datafim,
                        paramns.usuario,
                        paramns.tipoconsulta,
                        paramns.status,
                        paramns.page,
                        true
                    );
                }
            }, 10000);
            return () => clearInterval(interval);
        }
    }, [intervalLoop]);

    const fecharModal = (e) => {
        setAbrirModal(false);
    };

    const configPortal = usuarioService.getConfigPortal();

    const camposListagem = configPortal?.campos_listagem
        ? configPortal.campos_listagem
        : [];

    const espacoListagem = configPortal?.espaco_listagem
        ? configPortal.espaco_listagem
        : 12;

    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
        >
            <Box marginTop="2rem" width="80rem" maxWidth="95vw">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Grid container justifyContent="space-between">
                            <Grid item>
                                <Typography variant="h6">
                                    <Box fontWeight="bold">
                                        Relatórios de crédito
                                    </Box>
                                </Typography>
                            </Grid>
                            <Grid item>
                                {/* TODO: NOVO RELATORIO */}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={(e) => setAbrirModal(true)}
                                >
                                    Novo relatório
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Grid item md={2} xs={12}>
                                <TextField
                                    label="Buscar"
                                    fullWidth
                                    variant="outlined"
                                    type="text"
                                    size="small"
                                    value={campoBuscar}
                                    name="buscar"
                                    onChange={handleChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <Box
                                    lineHeight="2.5rem"
                                    textAlign="center"
                                    fontSize={12}
                                    color="#0000008A"
                                >
                                    Filtrar por
                                </Box>
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <Grid container>
                                    <Grid item xs={5}>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            inputVariant="outlined"
                                            size="small"
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="none"
                                            id="date-picker-inicio"
                                            label="Data Inicio"
                                            value={campoDataInicio}
                                            autoOk
                                            name="datainicio"
                                            onChange={(e) =>
                                                alterarData(
                                                    setCampoDataInicio,
                                                    e,
                                                    "datainicio"
                                                )
                                            }
                                            KeyboardButtonProps={{
                                                "aria-label": "change date",
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Box
                                            textAlign="center"
                                            lineHeight="2.5rem"
                                            color="#0000008A"
                                            bgcolor="#0000001F"
                                            fontSize={14}
                                        >
                                            Até
                                        </Box>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            inputVariant="outlined"
                                            size="small"
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="none"
                                            id="date-picker-inicio"
                                            label="Data Fim"
                                            value={campoDataFim}
                                            autoOk
                                            name="datafim"
                                            onChange={(e) =>
                                                alterarData(
                                                    setCampoDataFim,
                                                    e,
                                                    "datafim"
                                                )
                                            }
                                            KeyboardButtonProps={{
                                                "aria-label": "change date",
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item md={1} xs={12}>
                                <FormControl
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                >
                                    <InputLabel>Usuário</InputLabel>
                                    <Select
                                        value={campoUsuario}
                                        onChange={handleChange}
                                        name="usuario"
                                        label="Usuário"
                                        fullWidth
                                    >
                                        <MenuItem key={-1} value="">
                                            TODOS
                                        </MenuItem>
                                        {usuarios.map((u) => (
                                            <MenuItem key={u.id} value={u.id}>
                                                {u.nome}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item md={1} xs={12}>
                                <FormControl
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                >
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        value={campoStatus}
                                        onChange={handleChange}
                                        label="Status"
                                        name="status"
                                        fullWidth
                                    >
                                        <MenuItem value="">TODOS</MenuItem>
                                        <MenuItem value="2">
                                            PROCESSADA
                                        </MenuItem>
                                        <MenuItem value="3">ERRO</MenuItem>
                                        <MenuItem value="1">
                                            EM PROCESSAMENTO
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item md={2} xs={12}>
                                <FormControl
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                >
                                    <InputLabel>Tipo de consulta</InputLabel>
                                    <Select
                                        value={campoTipoConsulta}
                                        onChange={handleChange}
                                        name="tipoconsulta"
                                        label="Tipo de consulta"
                                        fullWidth
                                    >
                                        <MenuItem key={-1} value="">
                                            TODOS
                                        </MenuItem>
                                        {modelos.map((m) => (
                                            <MenuItem key={m.id} value={m.id}>
                                                {m.nome_consulta}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <Button size="small" onClick={limparFiltros}>
                                    Limpar filtros
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            <Box
                marginTop="1.5rem"
                width="80rem"
                maxWidth="95vw"
                marginBottom="1rem"
                minHeight="40rem"
            >
                <TableRelatorios
                    rows={relatorios}
                    pagina={pagina - 1}
                    limite={limite}
                    total={total}
                    camposListagem={camposListagem}
                    padding={espacoListagem}
                    handleChangePage={handleChangePage}
                />
            </Box>

            {/* MODAL */}
            <Modal
                open={abrirModal}
                onClose={fecharModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Grid>
                    <ModalRelatorios
                        submitRelatorio={submitRelatorio}
                        modelos={modelos}
                        fecharModal={fecharModal}
                        loading={loading}
                    />
                </Grid>
            </Modal>
        </Grid>
    );
};

export default Relatorios;
